import React from "react";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import DataTable from "react-data-table-component";
import "assets/css/dataTable.css";

const ContainerResultadosCheckDocsBDS3 = ({
  filter,
  handleOnChangeFilterResultados,
  columns,
  dataFiltered,
  stats,
  paginationComponentOptions,
  actionsMemo,
}) => {
  return (
    <Container fluid className="page-container">
      {stats && (
        <Row className="stats-row">
          <Col xs={12} sm={6} lg={4}>
            <div className="stat-card stat-card--info">
              <div className="stat-card__icon"><i className="nc-icon nc-paper-2" /></div>
              <div className="stat-card__content">
                <span className="stat-card__label">Empresas analizadas</span>
                <span className="stat-card__value">{stats.empresas}</span>
              </div>
            </div>
          </Col>
          <Col xs={12} sm={6} lg={4}>
            <div className="stat-card stat-card--warning">
              <div className="stat-card__icon"><i className="nc-icon nc-alert-circle-i" /></div>
              <div className="stat-card__content">
                <span className="stat-card__label">Con diferencias</span>
                <span className="stat-card__value">{stats.conDiferencia}</span>
              </div>
            </div>
          </Col>
          <Col xs={12} sm={6} lg={4}>
            <div className="stat-card stat-card--danger">
              <div className="stat-card__icon"><i className="nc-icon nc-simple-remove" /></div>
              <div className="stat-card__content">
                <span className="stat-card__label">Total diferencias</span>
                <span className="stat-card__value">{stats.totalDiferencias}</span>
              </div>
            </div>
          </Col>
        </Row>
      )}

      <Card className="data-card">
        <Card.Body>
          <div className="data-card__toolbar">
            <div className="search-input">
              <i className="nc-icon nc-zoom-split" />
              <input
                type="text"
                name="search"
                value={filter}
                autoComplete="off"
                placeholder="Filtrar por rut o tipo documento..."
                onChange={handleOnChangeFilterResultados}
              />
            </div>
            <Button className="btn-export" onClick={actionsMemo.onExport}>
              <i className="nc-icon nc-cloud-download-93" />
              Exportar CSV
            </Button>
          </div>
          <DataTable
            className="-striped -highlight"
            fixedHeader={true}
            columns={columns}
            data={dataFiltered}
            pagination
            paginationComponentOptions={paginationComponentOptions}
          />
        </Card.Body>
      </Card>
    </Container>
  );
};

export default ContainerResultadosCheckDocsBDS3;
